import React from 'react';
import stringFormat from 'string-format';

interface SelectsProps {
  className?: string;
  handleChange: (arg: string) => void;
  items: {[prop: string]: any}[];
  labelFormat: string;
  value?: string;
  valueFormat: string;
}

const Selects = ({className, handleChange, items, labelFormat, value, valueFormat}: SelectsProps) => {
  if (items.length < 1) {
    return (
      <div>-</div>
    );
  }

  return (
    <select
      className={className}
      onChange={e => handleChange(e.target.value)}
      value={value}
    >
      {items.map(item => {
        const optionValue = stringFormat(valueFormat, item);
        const optionLabel = stringFormat(labelFormat, item);
        return (
          <option key={optionValue} value={optionValue}>{optionLabel}</option>
        );
      })}
    </select>
  );
};

export default Selects;
